/*eslint-disable*/
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "Diese Antwort wurde gekürzt, da die Längenbegrenzung erreicht wurde, und ist möglicherweise unvollständig.",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "Diese Anfrage kann aus Sicherheitsgründen nicht beantwortet werden. Bitte formulieren Sie sie um oder fragen Sie zu einem anderen Thema.",
  "Cancel": "Abbrechen",
  "Change theme": "Thema ändern",
  "Clear chat": "Chat löschen",
  "Clear chat history": "Chat-Verlauf löschen",
  "Connecting...": "Verbindung wird hergestellt...",
  "Continue": "Fortfahren",
  "Decrease font size": "Schriftgröße verkleinern",
  "Disclaimer": "Haftungsausschluss",
  "Enter your message...": "Geben Sie Ihre Nachricht ein...",
  "Type your message...": "Geben Sie Ihre Nachricht ein...",
  "Error": "Fehler",
  "Font size": "Schriftgröße",
  "Increase font size": "Schriftgröße vergrößern",
  "Language": "Sprache",
  "MJ Lab": "MJ Labor",
  "Reset font size": "Schriftgröße zurücksetzen",
  "Respond time: {time}s": "Antwortzeit: {time}s",
  "Response time:": "Antwortzeit:",
  "Send": "Senden",
  "Settings": "Einstellungen",
  "Support the project": "Projekt unterstützen",
  "System": "System",
  "Theme": "Thema",
  "Thinking...": "Denke nach...",
  "Toggle theme": "Thema umschalten",
  "Welcome to Mila by MJ": "Willkommen bei Mila von MJ",
  "You asked:": "Sie fragten:",
  
  // Headers
  "Ministry of Commerce Laws Expert": "MoC-Rechtsexperte",
  "by MJ": "von MJ",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Hallo, ich bin {{name}}, ein von MJ entwickelter KI-Assistent.",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.": "Ich bin Experte für die Gesetze und Vorschriften des Handelsministeriums in Saudi-Arabien.",
  "Ask me a question, and I will gladly answer you.": "Stellen Sie mir eine Frage, und ich werde Ihnen gerne antworten.",
  "Do not share confidential data.": "Teilen Sie keine vertraulichen Daten mit.",
  "I am powered using": "Ich werde betrieben mit",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Haftungsausschluss:** {{name}} ist ein experimenteller KI-Assistent, der auf Grundlage von Daten aus den Gesetzen und Vorschriften des saudischen Handelsministeriums antwortet und Annahmen oder Ungenauigkeiten vermeidet. Ich übernehme keine Verantwortung für sein Verhalten oder die Richtigkeit seiner Antworten.",
  
  // Frameworks
  "Automatic detection": "Automatische Erkennung",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "A1. HM-Gesetz über Unternehmen",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "A2. HM-Gesetz über Berufsgesellschaften",
  "MOC_COMMERCIAL_REGISTER_LAW": "A3. HM-Handelsregistersgesetz",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "A4. HM-Gesetz des Handelsministeriums",
  "MOC_TRADE_NAMES_LAW": "A5. HM-Gesetz über Handelsnamen",
  "MOC_GCC_TRADEMARK_LAW": "A6. GCC-Markengesetz",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "B1. HM-Gesetz über Handelspapiere",
  "MOC_COMMERCIAL_PLEDGE_LAW": "B2. HM-Gesetz über Handelspfandrechte",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "B3. HM-Gesetz über Mobiliarsicherheiten",
  "MOC_INSOLVENCY_LAW": "B4. HM-Insolvenzgesetz",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "C1. HM-Gesetz über Handelsvertretungen",
  "MOC_FRANCHISE_LAW": "C2. HM-Franchisegesetz",
  "MOC_ECOMMERCE_LAW": "C3. HM-Gesetz über E-Commerce",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "C4. HM-Gesetz über Handelskammern",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "D1. HM-Gesetz über Handelsbücher",
  "MOC_COMMERCIAL_DATA_LAW": "D2. HM-Gesetz über Handelsdaten",
  "MOC_PUBLIC_WAREHOUSING_LAW": "D3. HM-Gesetz über öffentliche Lagerung",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "E1. HM-Gesetz über Normung und Metrologie",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "E2. HM-Gesetz über Kalibrierung und Messung",
  "MOC_PRIVATE_LABORATORIES_LAW": "E3. HM-Gesetz über private Laboratorien",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "E4. HM-Gesetz über Edelmetalle und Edelsteine",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "E5. HM-Gesetz zur Verwaltung von Chemikalienimporten",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "F1. HM-Gesetz über Rechnungslegung und Wirtschaftsprüfung",
  "MOC_VALUERS_LAW": "F2. HM-Gesetz über Gutachter",
  "MOC_ENGINEERS_LAW": "F3. HM-Gesetz über Ingenieure",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "G1. HM-Gesetz gegen Verschleierung",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "G2. HM-Gesetz gegen Geldwäsche",
  "MOC_ARBITRATION_LAW": "G3. HM-Schiedsgesetz",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "G4. HM-Gesetz zur Bekämpfung von Handelsverfälschung",
  "MOC_GCC_COMBATING_DUMPING_LAW": "G5. GCC-Gesetz zur Bekämpfung von Dumping",
  
  // Models
  "Claude by Anthropic": "Claude von Anthropic",
  "DeepSeek by Groq": "DeepSeek von Groq",
  "MJ Lab Mode": "MJ-Labor-Modus",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} Zeichen übrig",
  "{{remainingChars}} characters left": "{{remainingChars}} Zeichen übrig",
  
  // Error messages
  "An error occurred": "Ein Fehler ist aufgetreten",
  "Failed to change language": "Sprachänderung fehlgeschlagen",
  "Please try again": "Bitte versuchen Sie es erneut",
  "Connection lost": "Verbindung verloren",
  "Reconnecting...": "Verbindung wird wiederhergestellt...",
  "Nothing to clear": "Nichts zu löschen",
  "All messages cleared": "Alle Nachrichten gelöscht",
  "All data cleared": "Alle Daten gelöscht",
  "Storage limit reached": "Speicherlimit erreicht",
  "Some older messages were removed to save space.": "Einige ältere Nachrichten wurden entfernt, um Speicherplatz zu sparen.",
  
  // Additional keys
  "Font Size": "Schriftgröße",
  "Language changed to {locale}": "Sprache wurde auf {locale} geändert",
  "Select language": "Sprache auswählen",
  "Support": "Unterstützung",
  
  // Brand names (do not translate)
  "Mila": "Mila",
  
  // Message actions
  "Message copied to clipboard": "Nachricht in die Zwischenablage kopiert",
  "Read": "Lesen",
  "Summarize": "Zusammenfassen",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Nachrichtenvorschläge",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.": "Wählen Sie eine Frage, um schnell ein Gespräch über die Gesetze des saudischen Handelsministeriums zu beginnen.",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?": "Welche Hauptanforderungen gelten nach dem Gesellschaftsgesetz für die Gründung einer GmbH in Saudi-Arabien?",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?": "Wie regelt das Gesetz über Handelsvertretungen die Beziehungen zwischen ausländischen Unternehmen und saudischen Vertretern?",
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?": "Welchen Schutz bietet das saudische E-Commerce-Gesetz für Online-Verbraucher und Unternehmen?",
  
  // Audio Player Dialog
  "AI Summary": "KI-Zusammenfassung",
  "Listen to the summarized response using our AI Service.": "Hören Sie sich die zusammengefasste Antwort mit unserem KI-Service an.",
  "Generating summary...": "Zusammenfassung wird erstellt...",
  "Preparing audio...": "Audio wird vorbereitet...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Textverarbeitung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "Failed to auto-play audio. Click play to try again.": "Automatische Audiowiedergabe fehlgeschlagen. Klicken Sie auf Play, um es erneut zu versuchen.",
  "Failed to load audio. Please try again.": "Audio konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
  "Audio playback was aborted.": "Audiowiedergabe wurde abgebrochen.",
  "Network error occurred while loading audio.": "Netzwerkfehler beim Laden des Audios aufgetreten.",
  "Audio decoding failed.": "Audio-Dekodierung fehlgeschlagen.",
  "Audio format not supported.": "Audioformat wird nicht unterstützt.",
  "Failed to setup audio playback": "Einrichtung der Audiowiedergabe fehlgeschlagen",
  "Failed to generate speech": "Sprachgenerierung fehlgeschlagen",
  "Failed to generate audio. Please try again.": "Generierung von Audio fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "Failed to play audio. Please try again.": "Wiedergabe von Audio fehlgeschlagen. Bitte versuchen Sie es erneut."
};